import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'receivingReportEnableBinAndLotTracking',
})
export class ReceivingReportEnableBinAndLotTrackingPipe implements PipeTransform {
  transform(
    lotTracking :any,
    ftLocationBins :boolean,
    ftLotTracking :boolean,
  ) :unknown {
    return lotTracking && ftLocationBins && ftLotTracking;
  }
}
